<template>
  <li
    :key="subCategory.id"
    @click="() => onSubCategoryItemClick({link: formatSubCategoryLink})"
    class="text-[16px] group sm:hover:text-primary/80 transition-all duration-200 cursor-pointer p-0 m-0"
    aria-expanded="false"
    tabindex="0"
  >
    <div
      class="py-4 px-0 gap-2 w-full group-last:border-b-0 border-b-[.0625rem] border-b-[#e3e4e5] flex"
    >
      <strong
        :class="`${isActive ? 'text-primary border-b-primary font-bold' : 'text-[#46474a] border-b-[#e3e4e5]'} flex-1 rtl:text-right ltr:text-left font-[400]`"
      >{{subCategory[nameKey]}}</strong>
    </div>
  </li>
</template>

<script>
export default {
  data(){
    return {
      selectedSubCategoryId: "",
      isActive: false,
    }
  },
  props: {
    getCurrentQueryObj: {
      type: Function,
      required: true
    },
    subCategory: {
      type: Object,
      required: true,
      default: () => ({})
    },
    mainCategoryId: {
      type: [String, Number],
      required: true,
      default: ""
    },
    onSubCategoryItemClick: {
      type: Function,
      required: true
    }
  },
  computed: {
    formatSubCategoryLink() {
      try{
        let queryToUrl = `${`&main_category_id=${this.mainCategoryId}`}${`&category_id=${this.subCategory?.id}`}${`&from=list`}`.replace(/^&/, "");
        let encodedQuery = btoa(encodeURIComponent(queryToUrl));
        return `${this.ROUTESNAMES.user.products}?${encodedQuery}`;
      }catch{
        return `${this.ROUTESNAMES.user.products}`;
      }
    }
  },
  mounted(){
    this.isActive = this.getCurrentQueryObj()?.category_id == this.subCategory?.id;
  }
};
</script>

<style>
</style>